import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ConfigService } from "src/app/core/config.service";
import { FinOpsAwsAccountsDayMeasures } from "./finops-aws-accounts.model";
import { DateGranularityEnum } from "src/app/shared/enum/date-granularity.enum";

@Injectable({
    providedIn: 'root'
})
export class FinOpsAwsAccountsService {

    constructor(
        private httpClient: HttpClient,
        private configService: ConfigService
    ) {
    }

    loadFinOpsAwsAccountsHistoricalData(granularity: DateGranularityEnum, date: string) {
        return this.httpClient.get<FinOpsAwsAccountsDayMeasures>(`${this.configService.config.apiUrl}/finops/aws/accounts?date=${date}&granularity=${granularity}`)
    }

    loadFinOpsAwsAccountsMeasures(date: string) {
        return this.httpClient.get<FinOpsAwsAccountsDayMeasures>(`${this.configService.config.apiUrl}/finops/aws/accounts/measures?date=${date}`)
    }

}
